import React from 'react';
import './style.scss';

export default function Footer() {
  return (
    <div className='footer'>
        See More:
        <a
          href="http://joshualacey.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          JoshuaLacey.com
        </a>
    </div>
  );
}
